import styled from 'styled-components';

import CapsuleIcon from 'src/app/components/Elements/CapsuleIcon';
import { Card } from 'src/app/components/Elements/Card';
import { Typography } from 'src/app/components/Elements/Typography';

export const CardContent = styled('div')<{ isCopied: boolean }>`
  padding: ${props => props.theme.space.s4};
  display: flex;
  align-items: center;
  flex-grow: 1;
  cursor: ${props => (props.isCopied ? 'auto' : 'pointer')};
  & svg {
    margin-right: ${props => props.theme.space.s2};
    & path {
      fill: ${props => props.theme.colors.capsuleGreen50};
    }
  }
`;

export const ContactInfo = styled.div`
  display: flex;
  ${props => props.theme.mediaQueries.smallDown} {
    flex-direction: column;
  }
`;

export const FacilityInfo = styled.div`
  margin-left: ${props => props.theme.space.s4};
  width: 100%;
`;

export const CheckIconWrapper = styled(props => <CapsuleIcon {...props} />)`
  width: ${props => props.theme.space.s5};
`;

export const CopyIconWrapper = styled(props => <CapsuleIcon {...props} />)`
  display: inline-block;
  vertical-align: middle;
  margin-left: ${props => props.theme.space.s1};
`;

export const StyledCard = styled(props => <Card {...props} />)`
  display: flex;
  flex-direction: column;
  min-height: 165px;
  background-color: rgba(153, 191, 188, 0.12);
  border-color: ${props => props.theme.colors.capsuleGreen50};
  border-radius: ${props => props.theme.radii.small};
`;

export const HorziontallyCenteredTypography = styled(props => <Typography {...props} />)`
  flex-grow: 1;
  text-align: center;
`;

export const ContactSection = styled.div`
  display: flex;
  margin-right: ${props => props.theme.space.s4};
`;

export const ContactContainer = styled.div``;

export const FixedWidthTypography = styled(Typography)`
  ${props => props.theme.mediaQueries.smallDown} {
    width: 52px;
  }
`;
